<!-- popup for selecting project and scene -->
<div class="fdm-dialog fdm-fade" id="panel-upload-simple-project">
  <div class="fdm-overlay-full" (click)="dialogRef.close()"></div>
  <mat-card class="fdm-dropdown-panel">
    <mat-card-header class="header">
      <div translate class="subheading-2 title">MAP.SELECT_PROJECT</div>
      <div class="header-actions">
        <fa-icon icon="times" style="font-size:22px;margin-right:5px;" (click)="dialogRef.close()"></fa-icon>
      </div>
    </mat-card-header>
    <mat-card-content class="fdm-drag-drop-section">
      <div class="fdm-section">

        <div class="fdm-visual-group-chooser">
          <h6>{{ 'MAP.PROJECT_TYPE' | translate }}</h6>
        <mat-radio-group aria-label="Select an option" [(ngModel)]="addToExisting">
          <mat-radio-button [value]="newOne">{{ 'MAP.NEW_PROJECT' | translate }}</mat-radio-button>
          <mat-radio-button [value]="existing">{{ 'MAP.EXISTING_PROJECT' | translate }}</mat-radio-button>
        </mat-radio-group>
        </div>

        <div *ngIf="addToExisting === existing" class="fdm-visual-group">
          <mat-form-field>
            <mat-label> {{ 'MAP.PROJECT' | translate }}</mat-label>
            <mat-select (selectionChange)="loadScene()" [(ngModel)]="project" name="name">
              <mat-option *ngFor="let item of projects" [value]="item">
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'MAP.SCENE' | translate }}</mat-label>
            <mat-select [(ngModel)]="scene" name="name">
              <mat-option *ngFor="let item of scenes" [value]="item">
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div *ngIf="addToExisting === newOne" class="fdm-visual-group">
          <mat-form-field class="fdm-text-input">
            <input matInput [(ngModel)]="newProjectName" placeholder=" {{ 'MAP.PROJECT_NAME' | translate }}">
          </mat-form-field>
        </div>


      </div>
      <div class="fdm-centered fdm-buttons fdm-visual-group-actionbar">

        <button mat-raised-button color="normal" class="fdm-dialog-button" (click)="dialogRef.close()">
          <fa-icon icon="times-circle"></fa-icon>
          {{ 'GENERIC.CANCEL' | translate }}
        </button>

        <button mat-raised-button color="accent" class="fdm-dialog-button fdm-selected" (click)="ok()"
        [disabled]="(this.addToExisting === this.newOne && this.newProjectName.length < 2)">
          <fa-icon icon="check-circle"></fa-icon>
          {{ 'GENERIC.OK' | translate }}
        </button>

      </div>

    </mat-card-content>
  </mat-card>
</div>

